/* eslint-disable no-unused-vars */
// *******************************************************************************
// 1.0 - Triangle Illustrations
// *******************************************************************************

const triangleEle = new Rellax('[data-rellax]', { breakpoints: [768, 992, 1440] });
